import find from 'lodash/find';
import isEmpty from 'lodash/isEmpty';
import values from 'lodash/values';
import { createSelector } from '@reduxjs/toolkit';
import { getState } from '@yme/selectors/common';
export const getValidationState = createSelector(getState, (state) => state.forms);
export const getHasValidationErrors = (form) => createSelector(getValidationState, (state) => !isEmpty(find(values(state[form]), (item) => item.errors?.length > 0)));
export const getValidationFields = (form) => createSelector(getValidationState, (state) => state[form]);
